<ng-container *ngIf="!isLoading && selectedContact else loadingView">
    <H4 class="user-name">{{selectedContact?.user_name}}<span *ngIf="contactID" class="contact-id">{{contactID}}</span></H4>
    <div class="cas-flex-row push-down-2 cas-pad">
        <ng-container *ngTemplateOutlet="contactDetails"></ng-container>
        <ng-container *ngIf="!isOrganisation">
            <ng-container *ngTemplateOutlet="organisationDetails"></ng-container>
        </ng-container>
        <ng-container *ngIf="isOrganisation && organisationContacts.length > 0">
            <ng-container *ngTemplateOutlet="organisationContactsDiv"></ng-container>
        </ng-container>
        <div class="col-md-12 push-down-3" *ngIf="parentRef">
            <acabim-associated
                [viewOnly]="false"
                [componentConfigure]="componentConfigure"
                [parentRef]="parentRef"
                class="w-100"></acabim-associated>
        </div>

    </div>
    <div class="cas-action-buttons cas-action-buttons-bottom">
        <button
            [class.cas-button-right]="!canEdit"
            type="button"
            (click)="onCancel()">Close</button>
        <button *ngIf="contactID && canEdit" class="cas-button-action cas-button-right" (click)="onEdit(contactID)">Edit</button>
    </div>
</ng-container>

<ng-container *ngIf="showEdit">
    <acabim-modal
            [title]="'Edit contact'"
            [display]="showEdit"
            [footer]="false"
            fixHeight="80vh"
            (status)="toggleEditModal($event)"
            height="80vh">
        <acabim-admin-add-contact *ngIf="showEdit" [loadContact]="contactID" (submit)="submitEdit($event)"></acabim-admin-add-contact>
    </acabim-modal>
</ng-container>

<ng-template #contactDetails>
    <div class="col-md-6 push-down-2  cas-pad">
        <ng-container *ngIf="profileProperties">
            <acabim-data-display
                [dataMap]="profileProperties"
                title="Contact details"
                labelAlignment="right"
                valueAlignment="left"
                labelWidth="9rem"></acabim-data-display>
        </ng-container>
    </div>
</ng-template>

<ng-template #otherDetails>

</ng-template>

<ng-template #organisationDetails>
    <div class="col-md-6 push-down-2  cas-pad">
        <ng-container *ngIf="organisationProperties">
            <acabim-data-display
                    [dataMap]="organisationProperties"
                    title="Organisation details"
                    labelAlignment="right"
                    valueAlignment="left"
                    labelWidth="9rem"></acabim-data-display>
        </ng-container>
    </div>
</ng-template>

<ng-template #organisationContactsDiv>
    <div class="col-md-6 push-down-2 scroll cas-pad">
        <ng-container *ngIf="organisationContacts">
            <acabim-data-display
                    [dataMap]="organisationContacts"
                    title="Organisation contacts"
                    [noLabel]="true"
                    labelAlignment="right"
                    valueAlignment="left"
                    labelWidth="9rem"></acabim-data-display>
        </ng-container>
    </div>
</ng-template>

<ng-template #loadingView>
    <acabim-loading-view></acabim-loading-view>
</ng-template>
